import React, { useEffect, useState } from 'react';
import { applyTheme, getActiveTheme, watchSystemTheme, type Theme } from '@/theme/theme';
import styles from './ThemeToggle.module.scss';

export const ThemeToggle: React.FC = () => {
  const [theme, setTheme] = useState<Theme>(() => getActiveTheme());

  // Keep following the OS setting live for as long as the user hasn't
  // explicitly picked a theme via the toggle below.
  useEffect(() => watchSystemTheme(setTheme), []);

  const toggle = () => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    setTheme(next);
  };

  return (
    <button
      type="button"
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-pressed={theme === 'dark'}
      onClick={toggle}
      className={styles.toggle}
    >
      {theme === 'dark' ? (
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M12 4.5a1 1 0 0 1-1-1V2a1 1 0 1 1 2 0v1.5a1 1 0 0 1-1 1zm0 17a1 1 0 0 1-1-1V19a1 1 0 1 1 2 0v1.5a1 1 0 0 1-1 1zM4.5 12a1 1 0 0 1-1 1H2a1 1 0 1 1 0-2h1.5a1 1 0 0 1 1 1zm17 0a1 1 0 0 1-1 1H19a1 1 0 1 1 0-2h1.5a1 1 0 0 1 1 1zM6.3 7.7a1 1 0 0 1-1.4 0L3.8 6.6a1 1 0 1 1 1.4-1.4L6.3 6.3a1 1 0 0 1 0 1.4zm12 12a1 1 0 0 1-1.4 0l-1.1-1.1a1 1 0 1 1 1.4-1.4l1.1 1.1a1 1 0 0 1 0 1.4zM6.3 16.3a1 1 0 0 1 0 1.4l-1.1 1.1a1 1 0 1 1-1.4-1.4l1.1-1.1a1 1 0 0 1 1.4 0zm12-12a1 1 0 0 1 0 1.4l-1.1 1.1a1 1 0 1 1-1.4-1.4l1.1-1.1a1 1 0 0 1 1.4 0zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10z" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M20.7 14.6A8.5 8.5 0 0 1 9.4 3.3a1 1 0 0 0-1.2-1.3A10.5 10.5 0 1 0 22 15.8a1 1 0 0 0-1.3-1.2z" />
        </svg>
      )}
    </button>
  );
};
